import { styled as r } from "styled-components";
import { Theme as o } from "../../../../styles/themes/index.js";
import { CaptionLight as i, BodyLight as t } from "../../../../styles/typography/index.js";
import { MediaQuery as e } from "../../../../styles/variables.js";
const c = r.button`
  display: flex;
  align-items: center;
  width: 100%;
  height: 42px;
  padding: 0 12px;
  flex: 1 0 auto;
  text-decoration: none;
  border-radius: 12px;
  color: rgb(${o.colors.Alpha});
  background: rgb(${o.colors.Juliet});

  ${i}

  i {
    font-size: 24px;
    margin-right: 10px;
  }

  &:hover {
    cursor: pointer;
    background-color: rgb(${o.colors.Kilo});
  }

  &:disabled {
    background: inherit;
    cursor: default;
    color: rgb(${o.colors.Golf});
  }

  @media ${e.SCREEN_MD_UP} {
    ${t}
  }
`;
export {
  c as Container
};
